module.exports = __webpack_public_path__ + "img/richgo_expert_logo.63701986.svg";